import dispatchDataLayerEvent, { eventTypes } from './utils/dispatchDataLayerEvent';

/**
 * Manage the application navigation
 */
class Navigation {
  constructor(component, currentScreen = null) {
    this.component = component;

    this.currentScreen = currentScreen;

    this.onNextCallback = null;
    this.onBackCallback = null;
  }

  /**
   * Update the currentScreen on the component given, which is usually the
   * Model-View instance that's managing the app state.
   *
   * @param {string} screenName
   */
  navigate(screenName) {
    this.currentScreen = screenName;

    if (this.currentScreen !== screenName) {
      this._resetBackNextActions();
    }

    this.component.setState({ currentScreen: { name: screenName } }, () => {
      dispatchDataLayerEvent({
        event: eventTypes.PAGE_VIEW,
        user_type: window.USER_TYPE,
        label: screenName,
      });
    });
  }

  /**
   * Set a callback to invoke when the next() method is called. Useful to manage
   * a basic navigation system. This callback can be set on each page change.
   *
   * @param callback
   */
  onNext(callback) {
    this.onNextCallback = callback;
  }

  /**
   * Set a callback to invoke when the back() method is called. Useful to manage
   * a basic navigation system. This callback can be set on each page change.
   *
   * @param callback
   */
  onBack(callback) {
    this.onBackCallback = callback;
  }

  /**
   * Invoke the callback set using the onNext() method.
   */
  next() {
    this.onNextCallback && this.onNextCallback();
    this._resetBackNextActions();
  }

  /**
   * Invoke the callback set using the onBack() method.
   */
  back() {
    this.onBackCallback && this.onBackCallback();
    this._resetBackNextActions();
  }

  /**
   * Reset the callbacks set for the next() and back() methods whenever the
   * screen changes.
   *
   * @private
   */
  _resetBackNextActions() {
    this.onNextCallback = null;
    this.onBackCallback = null;
  }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/Navigation.js